import { Alert, Link, Typography } from "@mui/material";

export const IdvCheckStatus = ({ loading, idvCheck }) => {
  if (loading) {
    return null;
  }

  if (idvCheck?.status === "inviteReady") {
    const url = idvCheck?.idvInviteUrl;
    return (
      <Alert sx={{ my: 2 }} severity="info">
        IDV Check initated, invite ready
        <br />
        <Link href={url}>{url}</Link>
      </Alert>
    );
  }

  if (idvCheck?.status === "processing") {
    return (
      <Alert sx={{ my: 2 }} severity="info">
        IDV Check processing
      </Alert>
    );
  }

  if (
    idvCheck?.status === "webhook-received" &&
    idvCheck.idvStatus === "processed"
  ) {
    return (
      <Alert sx={{ my: 2 }} severity="success">
        <Typography>IDV Verification processed</Typography>
        <Typography>Result: {idvCheck.idvCheckResult?.result}</Typography>
      </Alert>
    );
  }
  if (
    idvCheck?.status === "webhook-received" &&
    idvCheck.idvStatus === "processing"
  ) {
    return (
      <Alert sx={{ my: 2 }} severity="info">
        <Typography>IDV Verification processing</Typography>
        <Typography>
          Sailor has completed journey and checks are being performed
        </Typography>
      </Alert>
    );
  }

  if (idvCheck.status === "error") {
    return (
      <Alert sx={{ my: 2 }} severity="error">
        IDV Check error: {idvCheck.error}
        {idvCheck?.axiosError && (
          <pre>{JSON.stringify(idvCheck.axiosError, null, 2)}</pre>
        )}
      </Alert>
    );
  }

  return (
    <Alert sx={{ my: 2 }} severity="info">
      IDV Check Status: {idvCheck.idvStatus} ({idvCheck.status})
    </Alert>
  );
};
